import { cn } from '@/utils/cn';
import type { ReactNode } from 'react';

interface BadgeProps {
  variant?: 'success' | 'warning' | 'danger' | 'info' | 'neutral' | 'brand';
  children: ReactNode;
  className?: string;
  /** Infobulle native, pour dire pourquoi sans charger la ligne. */
  title?: string;
}

const variants = {
  success: 'bg-success-50 text-success-700 border-success-200 dark:bg-success-500/15 dark:text-success-400 dark:border-success-500/20',
  warning: 'bg-warning-50 text-warning-700 border-warning-200 dark:bg-warning-500/15 dark:text-warning-400 dark:border-warning-500/20',
  danger: 'bg-danger-50 text-danger-700 border-danger-200 dark:bg-danger-500/15 dark:text-danger-400 dark:border-danger-500/20',
  info: 'bg-primary-50 text-primary-700 border-primary-200 dark:bg-primary-500/15 dark:text-primary-400 dark:border-primary-500/20',
  neutral: 'bg-neutral-100 text-neutral-600 border-neutral-200 dark:bg-neutral-500/15 dark:text-neutral-400 dark:border-neutral-500/20',
  brand: 'bg-brand-50 text-brand-700 border-brand-200 dark:bg-brand-500/15 dark:text-brand-400 dark:border-brand-500/20',
};

export function Badge({ variant = 'neutral', children, className, title }: BadgeProps) {
  return (
    <span
      title={title}
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium',
        variants[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
